import * as React from 'react';
import styled from 'styled-components';

import { InputSearch } from 'ui/inputs';
import { pxToRem } from 'utils/convert';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { SEARCH_DEBOUNCE_TIMEOUT_MS } from '../constants';

const { useEffect, useState } = React;

const displayText = {
  searchPlaceholder: 'Search journeys',
};

const WideInputText = styled(InputSearch)`
  width: ${pxToRem(304)};
`;

type DebouncedSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
};

export const DebouncedSearchInput = ({
  value: debouncedValue,
  onChange: setDebouncedValue,
}: DebouncedSearchInputProps) => {
  const [nonDebouncedValue, setNonDebouncedValue] = useState(debouncedValue);
  const cancelSearchDebouncer = useDebouncedEffect(
    () => {
      setDebouncedValue(nonDebouncedValue);
    },
    [nonDebouncedValue],
    {
      skipEffectOnMount: true,
      debounceTimeout: SEARCH_DEBOUNCE_TIMEOUT_MS,
    },
  );

  useEffect(() => {
    cancelSearchDebouncer();
    setNonDebouncedValue(debouncedValue);
  }, [debouncedValue]);

  return (
    <WideInputText
      data-test="workflow-index-search"
      id="workflow-search-input"
      onChange={setNonDebouncedValue}
      placeholder={displayText.searchPlaceholder}
      value={nonDebouncedValue}
    />
  );
};
